import { HttpClient, HttpParams } from '@angular/common/http';
import { ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { interval } from 'rxjs';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OnboardingComponent implements OnInit {

  customercode: string;
  corporatename: string;
  files: string;
  imageurl: string;
  Address1: string;
  Address2: string;
  website: string;
  personName: string;
  role: string;
  phonenumber: string;
  mobile: string;
  emailid: string;
  description: string;
  Cstatus: string;
  Status: boolean = false;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  public searchText: string;
  onboardExport = [] as any;
  Profilr = [] as any;
  AddCust = [] as any;
  AddCustRemove = [] as any;
  EditedOnboard = [] as any;
  EditedOnboardId: string;
  EditedCustId: string;
  myfile: string;
  isShownimage: boolean = true;
  isShownActiveCus: Boolean = true;
  EditedOnboardContactPerson = [] as any;
  EditedOnboardContactPersonId: string;
  StatusContact: boolean = false;
  isShownAddBtn: boolean = false;
  isShownSaveContact: boolean = true;
  isShownUpdateContact: boolean = true;
  isShownDeleteBtn: boolean = false;
  isShownClearBtn: boolean = true;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId :string;
  sOldOnboadId:string;

  displayedColumns: string[] = ['sno', 'customercode', 'corporatename', 'address1', 'weburl', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  displayedColumns1: string[] = ['sno', 'contactPersonName', 'role', 'emailId', 'phoneNo', 'mobileNo', 'status'];
  dataSource1: MatTableDataSource<any[]>;
  @ViewChild('Paginator1', { static: true }) paginator1: MatPaginator;
  @ViewChild('Sort1') sort1: MatSort;
  @ViewChild('TABLE1') table1: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    this.sOldOnboadId = this.sOnboardingId;
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('', 'Please Select A Customer First!');
      //return;
    }

    this.vRead = localStorage.getItem('OnboardingRead');
    this.vWrite = localStorage.getItem('OnboardingWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.BindOnboardGrid();
    this.BindOnboardExport();
    this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });

    interval(3000).subscribe(x => {
      this.sOnboardingId = localStorage.getItem('OnboardingId');
      if (this.sOldOnboadId != this.sOnboardingId) {
      this.BindOnboardGrid();
      this.BindOnboardExport();
      this.sOldOnboadId=this.sOnboardingId;
      }
    });
  }

  public uploadFile = (files) => {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    debugger;
    if (files.length == 0) {
      return;
    }
    debugger;
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.http.post(environment.apiUrl + 'Onboarding/UploadContent', formData).subscribe(
      (response) => {
        debugger;
        alert(response);

      },
      (error) => {
        debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        this.isShownimage = false;
        this.myfile = vErrorMsg1;
        this.isShownSuccess = false;
        this.SuccessMsg = "File Uploaded"

      }
    )

  }
  SubmitOnboard() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vcorpName = this.corporatename;
    var vcustomercode = this.customercode;
    var vmyfile = this.myfile;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vUrl = this.website;
    var vdescription = this.description;
    debugger;

    if (vcustomercode == undefined || vcustomercode == "" || vcustomercode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Customer Code.";
      return false;
    }

    if (vcorpName == undefined || vcorpName == "" || vcorpName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Customer Name.";
      return false;
    }

    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Address Line 1.";
      return false;
    }

    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2 = "";
    }

    if (vUrl == undefined || vUrl == "" || vUrl == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter WebSite.";
      return false;
    }
    if (vUrl != undefined && vUrl != "") {
      //<--Website URL Validation-->
      var regurl = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

      if (regurl.test(vUrl) == false) {
        this.isShownError = false;
        this.ErrorMsg = 'Website URL is not valid';
        return false;

      }
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = "";
    }
    debugger;
    if (this.AddCust != null) {
      if (this.AddCust.length != 0) {
        for (var i = this.AddCust.length - 1; i >= 0; i--) {
          var v1 = this.AddCust[i].personName;
          var v2 = this.AddCust[i].role;
          var v3 = this.AddCust[i].phonenumber;
          var v4 = this.AddCust[i].mobile;
          var v5 = this.AddCust[i].emailid;
          debugger;
          var vVarContPerson = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarPhone = ((document.getElementById(v3) as HTMLInputElement).value);
          var vVarMobile = ((document.getElementById(v4) as HTMLInputElement).value);
          var vVarEmail = ((document.getElementById(v5) as HTMLInputElement).value);
          debugger;
          if (vVarContPerson == undefined || vVarContPerson == "" || vVarContPerson == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Contact Person Name.";
            return false;
          }
          if (vVarRole == undefined || vVarRole == "" || vVarRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Role.";
            return false;
          }

          if (vVarPhone == undefined || vVarPhone == "" || vVarPhone == "0") {
            this.phonenumber = "";
          }

          if (vVarMobile == undefined || vVarMobile == "" || vVarMobile == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter mobile number.";
            return false;
          }

          if (vVarEmail == undefined || vVarEmail == "" || vVarEmail == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Email Id.";
            return false;
          }
          if (vVarEmail != undefined && vVarEmail != "") {
            //<--Email Validation-->
            var regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

            if (regEmail.test(vVarEmail) == false) {
              this.isShownError = false;
              this.ErrorMsg = 'Email ID is not valid';
              return false;

            }
          }


        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Contact Details..";
      return false;
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dcustomercode', this.customercode);
    params = params.append('dcorporatename', this.corporatename);
    params = params.append('dmyfile', this.myfile);
    params = params.append('daddress1', this.Address1);
    params = params.append('daddress2', this.Address2);
    params = params.append('dwebsite', this.website);
    params = params.append('ddescription', this.description);


    var value = this.http.get(environment.apiUrl + 'Onboarding/InsertOnboard', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vOnboardId = data;
        for (var i = this.AddCust.length - 1; i >= 0; i--) {
          var v1 = this.AddCust[i].personName;
          var v2 = this.AddCust[i].role;
          var v3 = this.AddCust[i].phonenumber;
          var v4 = this.AddCust[i].mobile;
          var v5 = this.AddCust[i].emailid;

          var vVarContPerson = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarPhone = ((document.getElementById(v3) as HTMLInputElement).value);
          var vVarMobile = ((document.getElementById(v4) as HTMLInputElement).value);
          var vVarEmail = ((document.getElementById(v5) as HTMLInputElement).value);

          let params1 = new HttpParams();
          params1 = params1.append('iOnboardId', vOnboardId);
          params1 = params1.append('icontactperson', vVarContPerson);
          params1 = params1.append('irole', vVarRole);
          params1 = params1.append('iphone', vVarPhone);
          params1 = params1.append('imobile', vVarMobile);
          params1 = params1.append('iemail', vVarEmail);
          var value = this.http.get(environment.apiUrl + 'Onboarding/InsertOnboardContact', { params: params1 }).toPromise().then(
            (data: any) => {
              debugger;
              this.customercode = "";
              this.corporatename = "";
              this.Address1 = "";
              this.Address2 = "";
              this.website = "";
              this.personName = "";
              this.role = "";
              this.phonenumber = "";
              this.mobile = "";
              this.emailid = "";
              this.description = "";
              this.AddCust = [];
              this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
              //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
              this.isShownSuccess = false;
              this.SuccessMsg = "Onboarding Inserted Sucessfully.";
              this.isShownimage = true;
              this.BindOnboardGrid();
              this.BindOnboardExport();
              return false;
            }).catch((data: any) => {
              var vDataError = JSON.stringify(data.error.text);
              var vErrorMsg = vDataError.replace('"', '');
              this.isShownSuccess = false;
              this.SuccessMsg = "Onboarding Inserted Sucessfully.";
              this.BindOnboardGrid();
              this.BindOnboardExport();
              this.customercode = "";
              this.corporatename = "";
              this.Address1 = "";
              this.Address2 = "";
              this.website = "";
              this.personName = "";
              this.role = "";
              this.phonenumber = "";
              this.mobile = "";
              this.emailid = "";
              this.description = "";
              this.isShownimage = true;
              this.AddCust = [];
              this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
              //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
              return false;
            })
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        } 
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Part Master Record Already Exist.";
          return false;
        }
        else {
        }
      });
  }

  AddOnboard() {
    debugger;
    var vLength = this.AddCust.length;
    var v1 = "vcontactperson" + (vLength + 1);
    var v2 = "vRole" + (vLength + 1);
    var v3 = "vPhone" + (vLength + 1);
    var v4 = "vMobile" + (vLength + 1);
    var v5 = "vemail" + (vLength + 1);
    this.AddCust.push({ personName: v1, role: v2, phonenumber: v3, mobile: v4, OnboardingId: "", emailid: v5 });
  }

  EditOnboard(item: any) {
    this.isShownSaveBtn = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedOnboard = item;
    

    var vOnboardId = this.EditedOnboard.onboardingId;
    var vCustId = this.EditedOnboard.customerid;
    var vcustomercode = this.EditedOnboard.customercode;
    var vcorpName = this.EditedOnboard.corporatename;
    var vAddress1 = this.EditedOnboard.address1;
    var vAddress2 = this.EditedOnboard.address2;
    var vUrl = this.EditedOnboard.weburl;
    var vlogo = this.EditedOnboard.logourl;
    //var vcontactperson = this.EditedOnboard.contactperson;
    //var vRole = this.EditedOnboard.role;
    //var vPhone = this.EditedOnboard.phone;
    //var vMobile = this.EditedOnboard.mobile;
    //var vemail = this.EditedOnboard.email;
    var vdescription = this.EditedOnboard.description;
    var vstatus = this.EditedOnboard.status;
    debugger;
    this.EditedOnboardId = vOnboardId;
    this.EditedCustId = vCustId;
    this.customercode = vcustomercode;
    this.corporatename = vcorpName;
    this.Address1 = vAddress1;
    this.Address2 = vAddress2;
    this.website = vUrl;
    this.description = vdescription;

    var cvname = vlogo.split("/");
    var fname = cvname[6];
    if (vlogo != undefined && vlogo != null && vlogo != "" && vlogo != "undefined"){
      this.isShownimage = false;
    
    }
    else
    this.isShownimage = true;

    this.myfile = vlogo;

    let params = new HttpParams();
    params = params.append('iOnboardingId', vOnboardId);
    var value = this.http.get(environment.apiUrl + 'Onboarding/GetOnboardContactPersonForGrid', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource1 = new MatTableDataSource(data);
        this.dataSource1.data = data;
        this.dataSource1.paginator = this.paginator1;
        this.dataSource1.sort = this.sort1;
      });
    this.isShownAddBtn = true;
    this.isShownSaveContact = false;
    this.isShownUpdateContact = true;
    this.isShownClearBtn = false;
    this.isShownDeleteBtn = true;
    // var v1 = vcontactperson;
    // var v2 = vRole;
    // var v3 = vPhone;
    // var v4 = vMobile;
    // var v5 = vemail;
    // this.AddCust = [];
    // this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
    // setTimeout(() => {
    //   debugger;
    //   var v11 = "Person1";
    //   ((document.getElementById(v11) as HTMLInputElement).value) = v1;
    //   var v12 = "Role1";
    //   ((document.getElementById(v12) as HTMLInputElement).value) = v2;
    //   var v13 = "PhoneNo1";
    //   ((document.getElementById(v13) as HTMLInputElement).value) = v3;
    //   var v14 = "MobileNo1";
    //   ((document.getElementById(v14) as HTMLInputElement).value) = v4;
    //   var v15 = "Email1";
    //   ((document.getElementById(v15) as HTMLInputElement).value) = v5;
    // }, 2000);
    // console.log(this.AddCust);


    debugger;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }

  }
  EditOnboardContactPerson(item: any) {
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.EditedOnboardContactPerson = item;
    this.EditedOnboardContactPersonId = this.EditedOnboardContactPerson.onboardingContatPersonsId;
    this.isShownActiveCus = false;

    if (this.EditedOnboardContactPerson.status == "Active") {
      this.StatusContact = false;
    }
    else {
      this.StatusContact = true;
    }

    var v1 = this.EditedOnboardContactPerson.contactPersonName;
    var v2 = this.EditedOnboardContactPerson.role;
    var v3 = this.EditedOnboardContactPerson.phoneNo;
    var v4 = this.EditedOnboardContactPerson.mobileNo;
    var v5 = this.EditedOnboardContactPerson.emailId;

    //personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" 
    var v11 = "vcontactperson1";
    ((document.getElementById(v11) as HTMLInputElement).value) = v1;
    var v12 = "vRole1";
    ((document.getElementById(v12) as HTMLInputElement).value) = v2;
    var v13 = "vPhone1";
    ((document.getElementById(v13) as HTMLInputElement).value) = v3;
    var v14 = "vMobile1";
    ((document.getElementById(v14) as HTMLInputElement).value) = v4;
    var v15 = "vemail1";
    ((document.getElementById(v15) as HTMLInputElement).value) = v5;

    this.isShownAddBtn = true;
    this.isShownSaveContact = true;
    this.isShownUpdateContact = false;
    this.isShownClearBtn = false;
  }

  UpdateOnboard() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownSaveBtn = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vcorpName = this.corporatename;
    var vcustomercode = this.customercode;
    var vmyfile = this.imageurl;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vUrl = this.website;
    var vdescription = this.description;
    debugger;

    if (vcustomercode == undefined || vcustomercode == "" || vcustomercode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Customer Code.";
      return false;
    }

    if (vcorpName == undefined || vcorpName == "" || vcorpName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Customer Name.";
      return false;
    }

    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Address Line 1.";
      return false;
    }

    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2 = "";
    }

    if (vUrl == undefined || vUrl == "" || vUrl == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter WebSite.";
      return false;
    }
    if (vUrl != undefined && vUrl != "") {
      //<--Website URL Validation-->
      var regurl = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

      if (regurl.test(vUrl) == false) {
        this.isShownError = false;
        this.ErrorMsg = 'Website URL is not valid';
        return false;

      }
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = "";
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";
    debugger;

    // if (this.AddCust != null) {
    //   if (this.AddCust.length != 0) {
    //     for (var i = this.AddCust.length - 1; i >= 0; i--) {
    //       var v1 = this.AddCust[i].personName;
    //       var v2 = this.AddCust[i].role;
    //       var v3 = this.AddCust[i].phonenumber;
    //       var v4 = this.AddCust[i].mobile;
    //       var v5 = this.AddCust[i].emailid;
    //       debugger;
    //       var vVarContPerson = ((document.getElementById(v1) as HTMLInputElement).value);
    //       var vVarRole = ((document.getElementById(v2) as HTMLInputElement).value);
    //       var vVarPhone = ((document.getElementById(v3) as HTMLInputElement).value);
    //       var vVarMobile = ((document.getElementById(v4) as HTMLInputElement).value);
    //       var vVarEmail = ((document.getElementById(v5) as HTMLInputElement).value);
    //       debugger;
    //       if (vVarContPerson == undefined || vVarContPerson == "" || vVarContPerson == "0") {
    //         this.isShownError = false;
    //         this.ErrorMsg = "Please Enter Contact Person Name.";
    //         return false;
    //       }
    //       if (vVarRole == undefined || vVarRole == "" || vVarRole == "0") {
    //         this.isShownError = false;
    //         this.ErrorMsg = "Please Enter Role.";
    //         return false;
    //       }

    //       if (vVarPhone == undefined || vVarPhone == "" || vVarPhone == "0") {
    //         this.phonenumber = "";
    //       }

    //       if (vVarMobile == undefined || vVarMobile == "" || vVarMobile == "0") {
    //         this.isShownError = false;
    //         this.ErrorMsg = "Please Enter mobile number.";
    //         return false;
    //       }

    //       if (vVarEmail == undefined || vVarEmail == "" || vVarEmail == "0") {
    //         this.isShownError = false;
    //         this.ErrorMsg = "Please Enter Email Id.";
    //         return false;
    //       }
    //       if (vVarEmail != undefined && vVarEmail != "") {
    //         //<--Email Validation-->
    //         var regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    //         if (regEmail.test(vVarEmail) == false) {
    //           this.isShownError = false;
    //           this.ErrorMsg = 'Email ID is not valid';
    //           return false;

    //         }
    //       }
    //     }
    //   }
    // }
    // else {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Enter Contact Details..";
    //   return false;
    // }
    let params = new HttpParams();
    debugger;
    params = params.append('ionboardId', this.EditedOnboardId);
    params = params.append('dcustomercode', this.customercode);
    params = params.append('dcorporatename', this.corporatename);
    params = params.append('dmyfile', this.myfile);
    params = params.append('daddress1', this.Address1);
    params = params.append('daddress2', this.Address2);
    params = params.append('dwebsite', this.website);
    params = params.append('ddescription', this.description);
    params = params.append('iStatus', vStatus);

    var value = this.http.get(environment.apiUrl + 'Onboarding/UpdateOnboard', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vOnboardId = data;
        this.customercode = "";
        this.corporatename = "";
        this.Address1 = "";
        this.Address2 = "";
        this.website = "";
        this.personName = "";
        this.role = "";
        this.phonenumber = "";
        this.mobile = "";
        this.emailid = "";
        this.description = "";
        this.AddCust = [];
        var vdata = [];
        this.dataSource1 = new MatTableDataSource(vdata);
        this.dataSource1.data = vdata;
        this.dataSource1.paginator = this.paginator1;
        this.dataSource1.sort = this.sort1;
        this.isShownActive = true;
        this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
        this.isShownDeleteBtn = false;
        this.isShownAddBtn = false;
        this.isShownSaveContact = true;
        this.isShownUpdateContact = true;
        this.isShownActiveCus = true;
        this.isShownClearBtn = true;

        this.isShownSuccess = false;
              this.SuccessMsg = "Onboarding Updated Sucessfully.";
              this.BindOnboardGrid();
              this.BindOnboardExport();
              this.isShownUpdateBtn = true;
              this.isShownSaveBtn = false;
              this.isShownimage = true;

        // for (var i = this.AddCust.length - 1; i >= 0; i--) {
        //   var v1 = this.AddCust[i].personName;
        //   var v2 = this.AddCust[i].role;
        //   var v3 = this.AddCust[i].phonenumber;
        //   var v4 = this.AddCust[i].mobile;
        //   var v5 = this.AddCust[i].emailid;

        //   var vVarContPerson = ((document.getElementById(v1) as HTMLInputElement).value);
        //   var vVarRole = ((document.getElementById(v2) as HTMLInputElement).value);
        //   var vVarPhone = ((document.getElementById(v3) as HTMLInputElement).value);
        //   var vVarMobile = ((document.getElementById(v4) as HTMLInputElement).value);
        //   var vVarEmail = ((document.getElementById(v5) as HTMLInputElement).value);

        //   let params1 = new HttpParams();
        //   params1 = params1.append('iOnboardId', vOnboardId);
        //   params1 = params1.append('iCustomerId', this.EditedCustId);
        //   params1 = params1.append('icontactperson', vVarContPerson);
        //   params1 = params1.append('irole', vVarRole);
        //   params1 = params1.append('iphone', vVarPhone);
        //   params1 = params1.append('imobile', vVarMobile);
        //   params1 = params1.append('iemail', vVarEmail);
        //   var value = this.http.get(environment.apiUrl + 'Onboarding/UpdateOnboardContact', { params: params1 }).toPromise().then(
        //     (data: any) => {
        //       debugger;
        //       this.customercode = "";
        //       this.corporatename = "";
        //       this.Address1 = "";
        //       this.Address2 = "";
        //       this.website = "";
        //       this.personName = "";
        //       this.role = "";
        //       this.phonenumber = "";
        //       this.mobile = "";
        //       this.emailid = "";
        //       this.description = "";
        //       this.AddCust = [];
        //       this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
        //       //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
        //       this.isShownSuccess = false;
        //       this.SuccessMsg = "Onboarding Updated Sucessfully.";
        //       this.BindOnboardGrid();
        //       this.BindOnboardExport();
        //       this.isShownUpdateBtn = true;
        //       this.isShownSaveBtn = false;
        //       this.isShownActive = true;
        //       this.isShownimage = true;
        //       return false;
        //     }).catch((data: any) => {
        //       var vDataError = JSON.stringify(data.error.text);
        //       var vErrorMsg = vDataError.replace('"', '');
        //       this.isShownSuccess = false;
        //       this.SuccessMsg = "Onboarding Updated Sucessfully.";
        //       this.BindOnboardGrid();
        //       this.BindOnboardExport();
        //       this.customercode = "";
        //       this.corporatename = "";
        //       this.Address1 = "";
        //       this.Address2 = "";
        //       this.website = "";
        //       this.personName = "";
        //       this.role = "";
        //       this.phonenumber = "";
        //       this.mobile = "";
        //       this.emailid = "";
        //       this.description = "";
        //       this.AddCust = [];
        //       this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
        //       //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
        //       this.isShownUpdateBtn = true;
        //       this.isShownSaveBtn = false;
        //       this.isShownActive = true;
        //       this.isShownimage = true;
        //       return false;
        //     })
        // }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }

  ClearOnboard() {

    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownUpdateBtn = true;
    this.isShownSaveBtn = false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.customercode = "";
    this.corporatename = "";
    this.Address1 = "";
    this.Address2 = "";
    this.website = "";
    this.personName = "";
    this.role = "";
    this.phonenumber = "";
    this.mobile = "";
    this.emailid = "";
    this.description = "";
    this.myfile = "";
    this.isShownimage = true;
    this.AddCust = [];
    var data = [];
    this.dataSource1 = new MatTableDataSource(data);
    this.dataSource1.data = data;
    this.dataSource1.paginator = this.paginator1;
    this.dataSource1.sort = this.sort1;
    this.isShownDeleteBtn = false;
    this.isShownAddBtn = false;
    this.isShownSaveContact = true;
    this.isShownUpdateContact = true;
    this.isShownClearBtn = true;
    this.isShownActiveCus = true;
    this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
    //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
  }
  SaveOnboadContactPerson() {
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    //this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
    var v1 = "vcontactperson1";
    var v2 = "vRole1";
    var v3 = "vPhone1";
    var v4 = "vMobile1";
    var v5 = "vemail1";
    debugger;
    var vVarContPerson = ((document.getElementById(v1) as HTMLInputElement).value);
    var vVarRole = ((document.getElementById(v2) as HTMLInputElement).value);
    var vVarPhone = ((document.getElementById(v3) as HTMLInputElement).value);
    var vVarMobile = ((document.getElementById(v4) as HTMLInputElement).value);
    var vVarEmail = ((document.getElementById(v5) as HTMLInputElement).value);
    debugger;
    if (vVarContPerson == undefined || vVarContPerson == "" || vVarContPerson == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Contact Person Name.";
      return false;
    }
    if (vVarRole == undefined || vVarRole == "" || vVarRole == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Role.";
      return false;
    }

    if (vVarPhone == undefined || vVarPhone == "" || vVarPhone == "0") {
      this.phonenumber = "";
    }

    if (vVarMobile == undefined || vVarMobile == "" || vVarMobile == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter mobile number.";
      return false;
    }

    if (vVarEmail == undefined || vVarEmail == "" || vVarEmail == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Email Id.";
      return false;
    }
    if (vVarEmail != undefined && vVarEmail != "") {
      //<--Email Validation-->
      var regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (regEmail.test(vVarEmail) == false) {
        this.isShownError = false;
        this.ErrorMsg = 'Email ID is not valid';
        return false;

      }
    }

    let params1 = new HttpParams();
    params1 = params1.append('iOnboardId', this.EditedOnboardId);
    params1 = params1.append('icontactperson', vVarContPerson);
    params1 = params1.append('irole', vVarRole);
    params1 = params1.append('iphone', vVarPhone);
    params1 = params1.append('imobile', vVarMobile);
    params1 = params1.append('iemail', vVarEmail);
    var value = this.http.get(environment.apiUrl + 'Onboarding/InsertOnboardContact', { params: params1 }).toPromise().then(
      (data: any) => {
        this.AddCust = [];
        this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
        //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
        this.isShownSuccess = false;
        this.SuccessMsg = "Onboarding Contact Person Inserted Sucessfully.";
        this.isShownActiveCus = true;
        this.isShownAddBtn = true;
        this.isShownSaveContact = false;
        this.isShownUpdateContact = true;
        let params = new HttpParams();
        params = params.append('iOnboardingId', this.EditedOnboardId);
        var value = this.http.get(environment.apiUrl + 'Onboarding/GetOnboardContactPersonForGrid', { params: params }).toPromise().then(
          (data: any) => {
            debugger;
            this.dataSource1 = new MatTableDataSource(data);
            this.dataSource1.data = data;
            this.dataSource1.paginator = this.paginator1;
            this.dataSource1.sort = this.sort1;
          });
        return false;
      }).catch((data: any) => {
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        this.isShownSuccess = false;
        this.isShownAddBtn = true;
        this.isShownSaveContact = false;
        this.isShownUpdateContact = true;
        this.SuccessMsg = "Onboarding Contact Person Inserted Sucessfully.";
        this.AddCust = [];
        this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
        //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
        let params = new HttpParams();
        params = params.append('iOnboardingId', this.EditedOnboardId);
        var value = this.http.get(environment.apiUrl + 'Onboarding/GetOnboardContactPersonForGrid', { params: params }).toPromise().then(
          (data: any) => {
            debugger;
            this.dataSource1 = new MatTableDataSource(data);
            this.dataSource1.data = data;
            this.dataSource1.paginator = this.paginator1;
            this.dataSource1.sort = this.sort1;
          });
        return false;
      })

  }

  UpdateOnboadContactPerson() {
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    //this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
    var v1 = "vcontactperson1";
    var v2 = "vRole1";
    var v3 = "vPhone1";
    var v4 = "vMobile1";
    var v5 = "vemail1";
    debugger;
    var vVarContPerson = ((document.getElementById(v1) as HTMLInputElement).value);
    var vVarRole = ((document.getElementById(v2) as HTMLInputElement).value);
    var vVarPhone = ((document.getElementById(v3) as HTMLInputElement).value);
    var vVarMobile = ((document.getElementById(v4) as HTMLInputElement).value);
    var vVarEmail = ((document.getElementById(v5) as HTMLInputElement).value);
    debugger;
    if (vVarContPerson == undefined || vVarContPerson == "" || vVarContPerson == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Contact Person Name.";
      return false;
    }
    if (vVarRole == undefined || vVarRole == "" || vVarRole == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Role.";
      return false;
    }

    if (vVarPhone == undefined || vVarPhone == "" || vVarPhone == "0") {
      this.phonenumber = "";
    }

    if (vVarMobile == undefined || vVarMobile == "" || vVarMobile == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter mobile number.";
      return false;
    }

    if (vVarEmail == undefined || vVarEmail == "" || vVarEmail == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Email Id.";
      return false;
    }
    if (vVarEmail != undefined && vVarEmail != "") {
      //<--Email Validation-->
      var regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (regEmail.test(vVarEmail) == false) {
        this.isShownError = false;
        this.ErrorMsg = 'Email ID is not valid';
        return false;

      }
    }
    var vStatus = "Active";
    if (this.StatusContact == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params1 = new HttpParams();
    params1 = params1.append('iOnboardId', this.EditedOnboardId);
    params1 = params1.append('iCustomerId', this.EditedOnboardContactPersonId);
    params1 = params1.append('icontactperson', vVarContPerson);
    params1 = params1.append('irole', vVarRole);
    params1 = params1.append('iphone', vVarPhone);
    params1 = params1.append('imobile', vVarMobile);
    params1 = params1.append('iemail', vVarEmail);
    params1 = params1.append('sStatus', vStatus);

    var value = this.http.get(environment.apiUrl + 'Onboarding/UpdateOnboardContact', { params: params1 }).toPromise().then(
      (data: any) => {
        this.AddCust = [];
        this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
        //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
        this.isShownSuccess = false;
        this.SuccessMsg = "Onboarding Contact Person Updated Sucessfully.";
        this.isShownActiveCus = true;
        this.isShownAddBtn = true;
        this.isShownSaveContact = false;
        this.isShownUpdateContact = true;
        this.isShownClearBtn = false;
        let params = new HttpParams();
        params = params.append('iOnboardingId', this.EditedOnboardId);
        var value = this.http.get(environment.apiUrl + 'Onboarding/GetOnboardContactPersonForGrid', { params: params }).toPromise().then(
          (data: any) => {
            debugger;
            this.dataSource1 = new MatTableDataSource(data);
            this.dataSource1.data = data;
            this.dataSource1.paginator = this.paginator1;
            this.dataSource1.sort = this.sort1;
          });
        return false;
      }).catch((data: any) => {
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        this.isShownSuccess = false;
        this.isShownAddBtn = true;
        this.isShownSaveContact = false;
        this.isShownUpdateContact = true;
        this.isShownClearBtn = false;
        this.SuccessMsg = "Onboarding Contact Person Updated Sucessfully.";
        this.AddCust = [];
        this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
        //this.AddCust.push({ personName: "Person1", role: "Role1", phonenumber: "PhoneNo1", mobile: "MobileNo1", emailid: "Email1" });
        let params = new HttpParams();
        params = params.append('iOnboardingId', this.EditedOnboardId);
        var value = this.http.get(environment.apiUrl + 'Onboarding/GetOnboardContactPersonForGrid', { params: params }).toPromise().then(
          (data: any) => {
            debugger;
            this.dataSource1 = new MatTableDataSource(data);
            this.dataSource1.data = data;
            this.dataSource1.paginator = this.paginator1;
            this.dataSource1.sort = this.sort1;
          });
        return false;
      })

  }
  ClearOnboadContactPerson() {
    this.AddCust = [];
    this.AddCust.push({ personName: "vcontactperson1", role: "vRole1", phonenumber: "vPhone1", mobile: "vMobile1", emailid: "vemail1" });
  }
  BindOnboardGrid() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Onboarding/GetOnboardForGrid',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });

  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindOnboardExport() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Onboarding/GetOnboardForExport',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.onboardExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.onboardExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Onboarding');

    /* save to file */
    XLSX.writeFile(wb, "Onboarding.xlsx");

  }
  RemoveCust(item: any) {
    debugger;
    this.AddCustRemove = item;

    if (this.AddCust != null) {

      if (this.AddCust.length != 0 && this.AddCust.length != 1) {
        for (var i = this.AddCust.length - 1; i >= 0; i--) {
          //vName: v1, vPrice: v2, vImage: v3
          var v1 = this.AddCust[i].CompanyName;
          var vNme = this.AddCustRemove.CompanyName;

          //if (v1 == vNme) {
          if (v1 == vNme) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You want to remove this Row!',

              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!',
              cancelButtonText: 'No, keep it'
            }).then((result) => {
              if (result.value) {
                this.AddCust.splice(i, 1);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Swal.fire(
                //   'Cancelled',
                //   'Your Row is safe :)',
                //   'error'
                // )
              }
            })

          }

          //}
        }
      }
      else {
        Swal.fire('', 'You Cannot Delete The Master Record.')
      }
    }
  }

}

